// Redux
import { createSelector, DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import { bapDuckPreset } from '@/ducks/presets';

import NewCarBoostFetcher from '@/fetchers/NewCarBoostFetcher';
import SimilarListingsFetcher from '@/fetchers/SimilarListingsFetcher';

import { inventoryDuck } from '..';

const bapSimilarInventoryDuck = objectDuckCreator({
    ...bapDuckPreset,
    store: 'similarListings',
    initialState: {
        similarListings: [],
    },
}).extend({
    creators: () => ({
        loadListings:
            ({ ownerId = '', minPrice, maxPrice, bodyStyleCode, modelCode, trim, hasNewCarBoost }) => async (dispatch, getState) => {
                const { query = {} } = getState();
                const currentYear = new Date().getFullYear();

                if (query?.experience === 'commercial') {
                    query.lifestyleCategory = 'Commercial';
                } else if (query?.experience === 'best-deals') {
                    query.dealType = ['goodprice', 'greatprice'];
                    query.excludedLifestyleCategory = 'Commercial';
                }

                const similarListingsCriteria = {
                    ...query,
                    numRecords: 20,
                    ownerId,
                    sortBy: 'yearDESC', // TODO update personalized-listing service to overwrite default sortBy
                    startYear: currentYear - 1,
                    endYear: currentYear + 1,
                    minPrice,
                    maxPrice,
                    bodyStyleCode,
                    modelCode,
                    trim,
                    listingType: 'NEW,CERTIFIED',
                };

                const newCarBoostCriteria = {
                    ...query,
                    dealerId: ownerId,
                    modelCodeToBoost: modelCode,
                    trimCodeToBoost: trim,
                    numRecords: 20,
                    minPrice,
                    maxPrice,
                    bodyStyleCode,
                };

                let fetchListings = null;

                if (hasNewCarBoost) {
                    fetchListings = NewCarBoostFetcher(newCarBoostCriteria);
                } else {
                    fetchListings = SimilarListingsFetcher(similarListingsCriteria);
                }

                const { listings = [] } = await fetchListings;

                await dispatch(inventoryDuck?.creators?.addInventory(listings));

                await dispatch(
                    bapSimilarInventoryDuck?.creators?.setKeys({
                        similarListings: listings,
                    })
                );
            },
    }),
    selectors: () => ({
        getSimilarListings: new DuckSelector((selectors) => createSelector(selectors.getDuckState, ({ similarListings = {} }) => similarListings)),
    }),
});

export default bapSimilarInventoryDuck;
